import {
  DOCUMENT_STATUS_FILTER_OPTIONS,
  DOCUMENT_STATUS_LABELS,
  formatDocumentStatusLabel,
} from '#/modules/imsMgmt/receipts/shared/documentStatus';

export const STOCK_ADJUSTMENT_STATUS_LABELS = DOCUMENT_STATUS_LABELS;
export const STOCK_ADJUSTMENT_STATUS_FILTER_OPTIONS = DOCUMENT_STATUS_FILTER_OPTIONS;

export const ADJUSTMENT_TYPE_OPTIONS = [
  { value: 'QTY_ADJUST', label: '數量調整' },
];

export function canEditStockAdjustment(status) {
  return status === 'DRAFT';
}

export function canEditStockAdjustmentRemark(status) {
  return status === 'COMPLETED';
}

export function canPrintStockAdjustmentLabel(status) {
  return status === 'COMPLETED';
}

export function canSubmitStockAdjustment(status) {
  return status === 'DRAFT';
}

export function canCancelStockAdjustment(status) {
  return status === 'DRAFT';
}

export function canApproveStockAdjustment(status) {
  return status === 'SUBMITTED';
}

export function canRejectStockAdjustment(status) {
  return status === 'SUBMITTED';
}

export function formatStockAdjustmentStatusLabel(status) {
  return formatDocumentStatusLabel(status);
}

export function formatAdjustmentTypeLabel(type) {
  const found = ADJUSTMENT_TYPE_OPTIONS.find((item) => item.value === type);
  return found?.label ?? type ?? '-';
}
